/**
 * Last correlation id seen on any API response (Constitution XVIII): surfaced
 * in error states as the support code and attached to error reports.
 */
let lastCorrelationId: string | null = null;

export function setLastCorrelationId(id: string) {
  lastCorrelationId = id;
}

export function getLastCorrelationId(): string | null {
  return lastCorrelationId;
}

/** Captures the support code from fetch calls that bypass the generated API middleware. */
export function captureResponseCorrelationId(response: Response): void {
  const correlationId = response.headers.get('X-Correlation-Id');
  if (correlationId) setLastCorrelationId(correlationId);
}
